export default "__VITE_PUBLIC_ASSET__41d9957d__"